import { render, staticRenderFns } from "./NavAnchor.vue?vue&type=template&id=c680965c&scoped=true&"
import script from "./NavAnchor.vue?vue&type=script&lang=js&"
export * from "./NavAnchor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c680965c",
  null
  
)

export default component.exports